module.exports = __webpack_public_path__ + "img/je.6aade315.png";